import React from 'react';
import './Teaching.css';
import { useLanguage } from '../../contexts/LanguageContext';
import { useContent } from '../../contexts/ContentContext';

interface Course {
  title: string;
  organization?: string;
  period?: string;
  role?: string;
  status?: string;
  statusLabel?: string;
  description?: string;
  topics?: string[];
  highlights?: string[];
  links?: Array<{ label: string; url: string }>;
}

const Teaching: React.FC = () => {
  const { language } = useLanguage();
  const { content, isLoading } = useContent();

  if (isLoading || !content) return null;

  const teaching = content.teaching[language];

  return (
    <section id="teaching" className="section teaching-section">
      <h2 className="section-title">{teaching.title}</h2>
      
      <div className="teaching-content">
        {teaching.courses.map((course: Course, index: number) => (
          <article key={index} className="teaching-card fade-in">
            <div className="teaching-card-header">
              <h3 className="teaching-course-title">{course.title}</h3>
              {course.status && (
                <span className={`teaching-status-badge ${course.status}`}>
                  {course.statusLabel}
                </span>
              )}
            </div>
            
            <div className="teaching-course-info">
              {course.organization && (
                <p className="teaching-organization">{course.organization}</p>
              )}
              {course.period && (
                <p className="teaching-period">{course.period}</p>
              )}
              {course.role && (
                <p className="teaching-role">{course.role}</p>
              )}
            </div>
            
            {course.description && (
              <p className="teaching-description">{course.description}</p>
            )}
            
            {course.topics && course.topics.length > 0 && (
              <div className="teaching-topics">
                <h4 className="teaching-topics-title">
                  {language === 'jp' ? '主なトピック' : 'Main Topics'}
                </h4>
                <ul className="teaching-topics-list">
                  {course.topics.map((topic: string, idx: number) => (
                    <li key={idx} className="teaching-topic-item">{topic}</li>
                  ))}
                </ul>
              </div>
            )}
            
            {course.highlights && course.highlights.length > 0 && (
              <div className="teaching-highlights">
                {course.highlights.map((highlight: string, idx: number) => (
                  <div key={idx} className="teaching-highlight-item">
                    <span className="highlight-icon">✓</span>
                    <span className="highlight-text">{highlight}</span>
                  </div>
                ))}
              </div>
            )}
            
            {course.links && course.links.length > 0 && (
              <div className="teaching-links">
                {course.links.map((link: { label: string; url: string }, idx: number) => (
                  <a
                    key={idx}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="teaching-link"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};

export default Teaching;

